import React, { useEffect, useState, useLayoutEffect } from "react";
import "./generalReports.css";
import FilterBox from "../../Components/filterBox/filterBox";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import Button from "../../Components/commonButton/commonButton";
import Spinner from "react-bootstrap/Spinner";
import { Badge } from "react-bootstrap";
import styles from "../General/details.module.css";
import "./generalReports.css";


const reportMachines = () => {
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [filters, setFilters] = useState([]);
  const [control, setControl] = useState([1]);
  const [loading, setLoading] = useState(true);

  //Esse use effect faz a requisição na api e puxa os dados pela primeira vez. Coloquei o nome de componentDidMount() pois ele executa somente na primeira renderização.

  // Esse use effect faz a requisição na api e puxa os dados pela primeira vez. 
  // Coloquei o nome de componentDidMount() pois ele executa somente na primeira renderização.

  useEffect(() => {
    async function firstLoad() {
      let array = [];

      const machines = await Api.get("/machines");
      try {
        machines.data.forEach(
          async ({
            description,
            code,
            factory,
            department,
            work_shifts,
            oee_goal,
            is_machine,
          }) => {
            let workshifts = [];

            // Coletando todos os turnos em paralelo
            const shiftPromises = work_shifts.map(async (ws) => {
              const work_shifts_req = await Api.get(`/work-shifts/${ws}`);
              if (work_shifts_req.data && work_shifts_req.data.code) {
                workshifts.push(
                  <Badge key={ws} bg="primary" pill>
                    {work_shifts_req.data.code}
                  </Badge>
                );
              }
            });

            await Promise.all(shiftPromises);
            let appointment = is_machine === 1 ? "Automático" : "Manual";

            const workshiftsEnd = (
              <div
                style={{ display: "flex", flexDirection: "row", gap: "5px" }}
              >
                {workshifts}
              </div>
            );

            array.push({
              Máquina: description + code,
              ["Planta"]: factory.factory_name,
              Setor: department,
              Turno: workshiftsEnd,
              "Meta OEE": `${oee_goal}%`,
              Apontamento: (
                <Badge
                  bg={appointment === "Manual" ? "secondary" : "dark"}
                  pill
                >
                  {appointment}
                </Badge>
              ),
            });

            if (machines.data.length === array.length) {
              setData(array);
              setDataFilter(array);
              setLoading(false);
            }
          }
        );
      } catch (error) {
        if (error.response.status === 500) {
          alert("Erro ao carregar os dados. Tente novamente mais tarde.");
        }
        setLoading(false);
      }
    }

    firstLoad();

  }, []);

  useEffect(() => {
    //Captura o nome dos filtros que estão sendo usados.
    let aux = Object.keys(filters);
    //Se existir uma filtragem ele usa a função .filter para filtrar o state data e armazenar em uma variável arr. 
    if (aux.length > 0 && filters[aux] != null && filters[aux] != "") {
      let arr = data.filter(element => (element[aux] == filters[aux]));

      //Depois ele armazena a varíavel arr no state dataFilter;
      setDataFilter([...arr]);


    } else {
      setDataFilter([...data]);
    }

    setLoading(false);
  }, [control])

  //Essa função serve para capturarmos e armazenarmos em um state "filters" o que está sendo digitado nos filtros.

  const saveText = (element) => {

    const { value, name } = element;
    setFilters({ [`${name}`]: (value) });

  }

  const button = () => {
    setLoading(true);
    setControl([...[1]]);
  };

 


  return (
    <div className="filters boxReport">
      <FilterBox title="Filtros">
        <div className="elementFilter" type="input">
          <InputReport
            name="Máquina"
            title="Máquina"
            parentCallback={saveText}
            value={filters["Máquina"]}
            max={30}
            validationType="varchar"
            focus={true}
          />
        </div>
        <div className="elementFilter" type="input">
          <InputReport
            name="Planta"
            title="Planta"
            value={filters["Planta"]}
            max={30}
            validationType="varchar"
            parentCallback={saveText}
          />
        </div>
        <div className="elementFilter" type="input">
          <InputReport
            name="Setor"
            title="Setor"
            value={filters["Setor"]}
            max={30}
            validationType="varchar"
            parentCallback={saveText}
          />
        </div>
        <div className="submitButton" type="button">
          <Button size title="Gerar" icon="faGear" parentCallback={button} />
        </div>
      </FilterBox>
      <div className="TableReport" id="tabela">
        {loading ? (
          <div style={{ marginTop: "20vh" }} className={styles.loader}>
            <Spinner variant="success" animation="border" />
            <strong>Carregando...</strong>
          </div>
        ) : (
          <>
            {dataFilter.length > 0 ? (
              <TableList data={dataFilter}></TableList>
            ) : (
              <MessageTable message={"Sem dados para processar."} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default reportMachines;
